export default {
    namespaced: true,
    state: () => ({
        previewInfo: {
            upperButtonName: "",
            lowerButtonName: "",
            displayFlg: 0,
            headerItemList: null,
            cookingList: null,
            dailyCheckButtonName: "",
        },
        previewItems: {
            pageId: 0,
            dailyCheckPageName: "",
            dailyCheckItemNames: [],
            dailyCheckItemCommentDisplayFlg: [],
            arrangementRuleCount: 0,
            allButtonDisplayFlg:0,
        }
    }),
    getters: {
        upperButtonName (state) {
            return state.previewInfo.upperButtonName
        },
        lowerButtonName (state) {
            return state.previewInfo.lowerButtonName
        },
        dailyCheckButtonName (state) {
            return state.previewInfo.dailyCheckButtonName
        },
        displayFlg (state) {
            return state.previewInfo.displayFlg
        },
        pageId (state) {
            return state.previewItems.pageId
        },
        dailyCheckPageName (state) {
            return state.previewItems.dailyCheckPageName
        },
        dailyCheckItemNames (state) {
            return state.previewItems.dailyCheckItemNames
        },
        dailyCheckItemCommentDisplayFlg (state) {
            return state.previewItems.dailyCheckItemCommentDisplayFlg
        },
        arrangementRuleCount (state) {
            return state.previewItems.arrangementRuleCount
        },
        headerItem: (state) => (id) => {
            if(!state.previewInfo.headerItemList){
                return null;
            }
            const button = state.previewInfo.headerItemList.filter(obj => {
                return obj.cookingCheckHeaderId == id
            });
            return button.shift()
        },
        cookingList (state) {
            return state.previewInfo.cookingList;
        },
        allButtonDisplayFlg (state) {
            return state.previewItems.allButtonDisplayFlg
        },
    },
    mutations: {
        setPreviewInfo(state, previewInfo) {
            state.previewInfo = previewInfo
        },
        setPreviewItems(state, previewItems) {
            state.previewItems = previewItems
        },
        clear(state) {
            state.previewInfo = {
                upperButtonName: null,
                lowerButtonName: null,
                displayFlg: null,
                headerItemList: null,
                cookingList: null
            };
        }
    },
    actions: {
        setPreviewInfo({ commit }, previewInfo) {
            previewInfo['displayFlg'] = Number(previewInfo.displayFlg);
            commit('setPreviewInfo', previewInfo)
        },
        setPreviewItems({ commit }, previewItems) {
            commit('setPreviewItems', previewItems)
        },
        clearPreviewInfo({ commit }) {
            commit('clearPreviewInfo')
        },
        doClear({ commit }) {
            commit('clear')
        }
    },
}
